import { describeFields } from '../common/fields';
import { PermissionGroupSchema } from './schemas';

export const PERMISSION_GROUP_FIELDS = describeFields(PermissionGroupSchema, {
  groupId: {},
  name: {},
  users: {},
  basePermissions: {},
  currPermissions: {},
});
